/**
 * @generated SignedSource<<e5ebe3e600971ac9ac08bf4620f30dd1>>
 * @relayHash 3945251386fe89239e6f0387bd48ebb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7446ad327c9f26fd4546b61ce3a1764537c17f301cf281441041c50515271ae2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getGroupProps_suggestedGroupsQuery$variables = {
  cloudId: string;
};
export type getGroupProps_suggestedGroupsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getGroupProps_suggestedGroupsQuery = {
  response: getGroupProps_suggestedGroupsQuery$data;
  variables: getGroupProps_suggestedGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlBuilder",
      "kind": "LinkedField",
      "name": "jqlBuilder",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "context",
              "value": "GROUP"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "JiraJqlGroupFieldValueConnection",
          "kind": "LinkedField",
          "name": "suggestedGroups",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraJqlGroupFieldValueEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraJqlGroupFieldValue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jqlTerm"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getGroupProps_suggestedGroupsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getGroupProps_suggestedGroupsQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "7446ad327c9f26fd4546b61ce3a1764537c17f301cf281441041c50515271ae2",
    "metadata": {},
    "name": "getGroupProps_suggestedGroupsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "21cb7dab1c11c40821565c83fb2a4b80";

export default node;
